<template>
  <div
    class="drawers"
    :class="{ [position_]: true, active: open_ }"
    >
    <div class="drawers-mask" ref="mask" @click="handleMaskTap"></div>
    <div class="drawers-container" :class="{active: open_ }" ref="container" :style="{ transform: initTransform }">
      <slot></slot>
    </div>
    <!-- <transition name="slide-fade">
      <div class="drawers-container" v-if="open_" :style="{ width: initWidth }">
        <slot></slot>
      </div>
    </transition> -->
  </div>
</template>

<script>
const POSITIONS = ['right', 'left', 'top', 'bottom'];
import drawer from "@/mixins/drawer.js"
export default {
  name: "drawers",
  mixins: [drawer],
  props: {
    open: {
      type: Boolean,
      default: false
    },
    position: {
      type: String,
      default: "right"
    },
    size: {
      type: String,
      default: '300px'
    }
  },
  model: {
    prop: "open",
    event: "open-change"
  },
  watch: {
    open(val) {
      const mask = this.$refs['mask']
      if (val) {
        mask.style.width = '100vw'
        mask.style.height = '100vw'
      } else {
        setTimeout(_ => {
          mask.style.width = '0'
          mask.style.height = '0'
        }, 300)
      }
      this.open_ = val;
    },
  },
  data() {
    return {
      open_: false,
      position_: "right",
    };
  },
  computed: {
    initTransform() {
      const percentage = this.size
      const widthSize = (this.screenWidth* (percentage / 100)) + 'px'
      const heightSize = (this.screenHeight * (percentage / 100)) + 'px'
      // const transform = {
      //   right: `translateX(${ this.size })`,
      //   left: `translateX(-${ this.size })`,
      //   top: `translateY(-${ this.size })`,
      //   bottom: `translateY(${ this.size })`
      // }
      const transform = {
        right: `translateX(${ widthSize })`,
        left: `translateX(-${ widthSize })`,
        top: `translateY(-${ heightSize })`,
        bottom: `translateY(${ heightSize })`
      }
      return transform[this.position_]
    },
    // initWidth() {
    //   if (POSITIONS.indexOf(this.position_) < 2 && this.open_) {
    //     return this.size + '%'
    //   }else {
    //     return 0
    //   }
    // },
    // initHeight() {
    //   if (POSITIONS.indexOf(this.position_) >= 2 && this.open_) {
    //     return this.size + '%'
    //   }else {
    //     return 0
    //   }
    // }
  },
  created() {
    this.position_ = this.position && POSITIONS.includes(this.position)
      ? this.position
      : "right";
  },
  mounted() {
    const that = this
    if (POSITIONS.indexOf(this.position_) < 2) {
      this.$refs['container'].style.width = this.size + '%'
    } else {
      this.$refs['container'].style.height = this.size + '%'
    }
  },
  methods: {
    handleMaskTap(e) {
      this.$emit('open-change', false)
    }
  }
};
</script>

<style <style lang="postcss">
/* .slide-fade-enter-active {
  transition: all 1s;
}
.slide-fade-leave-active {
  transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
 {
  transform: translateX(10px);
  opacity: 0;
} */
.drawers {
  .drawers-container {
    position: fixed;
    background-color: #fff;
    z-index: 1000;
    opacity: 0;
    transition: 0.3s all cubic-bezier(0.165, 0.84, 0.44, 1);
    height: 100%;
  }
  &.right {
    .drawers-container {
      top: 0;
      right: 0;
      height: 100vw;
      transform: translateX(300px);
    }
  }
  &.left {
    .drawers-container {
      left: 0;
      top: 0;
      height: 100vw;
      transform: translateX(-300px);
    }
  }
  &.top {
    .drawers-container {
      top: 0;
      left: 0;
      width: 100vw;
      transform: translateY(-300px);
    }
  }
  &.bottom {
    .drawers-container {
      top: 0;
      bottom: 0;
      width: 100vw;
      transform: translateY(300px);
    }
  }
  &.active {
    .drawers-container {
      transform: translate(0, 0) !important;
      box-shadow: -3px 0 10px rgba(0,0,0,.1);
      opacity: 1;
    }
    .drawers-mask {
      opacity: 0.5;
    }
  }
  .drawers-mask {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    opacity: 0;
    background-color: #000;
    transition: 0.2s opacity ease;
    cursor: pointer;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Drawer.vue